module.exports = __webpack_public_path__ + "img/spedizione-preavviso.b44a6ad5.png";